"use strict";
define(
'actions/sessions',[
	"backbone",
	"dispatcher/AppDispatcher",
	"constants/actiontypes"
],
function(Backbone, AppDispatcher, Constants) {
	return Backbone.Model.extend({
		pull: function (onComplete, onFail) {
			if (!window.api) {
				throw new Error("Expected API client at [window.api].");
			}

			var fetchPromise = fetch('/session/all');
			fetchPromise.then(function(response) {
				if (!response) {
					console.error("Invalid response from badges endpoint.", response);
					return;
				}
				response.json().then(function(data) {
					AppDispatcher.dispatch({
						actionType: Constants.ADD_SESSIONS,
						data: data.sessions
					});
				});
			});
		}
	});
});
